import React, { useState } from 'react';
import { Button } from '../ui/button';
import { CheckCircle } from 'lucide-react';
import { IndustryCarousel, BedarfsanalyseForm, BedarfsanalyseResult } from '../IndustryCarousel';

const IndustriesSection = ({ onOpenDemo }) => {
  const [showAssessment, setShowAssessment] = useState(false);
  const [assessmentData, setAssessmentData] = useState({});
  const [assessmentResult, setAssessmentResult] = useState(null);

  const handleOpenDemo = (industry) => {
    if (onOpenDemo) {
      onOpenDemo(industry);
    }
  };

  return (
    <section id="industries" className="py-20 bg-white relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-teal-100 rounded-full opacity-20 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-100 rounded-full opacity-20 blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Heading above Industry Tabs */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            IDA Einsatzgebiete
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Maßgeschneiderte Compliance-Lösungen für Ihre Branche
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-700 to-blue-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Industry Tabs */}
        <IndustryCarousel onOpenDemo={handleOpenDemo} />

        {/* TEMPORARILY DISABLED: Bedarfsanalyse Section */}
        {/*
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl p-4 sm:p-8 border border-gray-200">
            {!showAssessment && !assessmentResult && (
              <>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-4 sm:mb-6 text-center">
                  Passt IDA zu Ihrem Betrieb?
                </h2>
                <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 text-center">
                  Finden Sie in nur 2 Minuten heraus, wie IDA Ihre Prozesse optimieren kann
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-6 sm:mb-8">
                  <div className="flex items-center gap-2 justify-center">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-sm sm:text-base text-gray-700">10 relevante Fragen</span>
                  </div>
                  <div className="flex items-center gap-2 justify-center">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-sm sm:text-base text-gray-700">Individuelles Ergebnis</span>
                  </div>
                  <div className="flex items-center gap-2 justify-center">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-sm sm:text-base text-gray-700">Kostenlose Beratung</span>
                  </div>
                </div>

                <div className="mt-6 sm:mt-8 flex justify-center">
                  <Button
                    size="lg"
                    className="bg-teal-500 hover:bg-blue-600 text-white px-8 sm:px-12 lg:px-16 py-4 sm:py-6 lg:py-8 text-lg sm:text-xl lg:text-2xl font-bold rounded-xl shadow-2xl transform hover:scale-110 transition-all duration-300 border-2 border-white w-full sm:w-auto max-w-full"
                    onClick={() => setShowAssessment(true)}
                  >
                    🎯 Bedarfsanalyse starten
                  </Button>
                </div>
              </>
            )}

            {showAssessment && !assessmentResult && (
              <BedarfsanalyseForm
                key="assessment-form"
                data={assessmentData}
                setData={setAssessmentData}
                onComplete={(result) => setAssessmentResult(result)}
              />
            )}

            {assessmentResult && (
              <BedarfsanalyseResult
                result={assessmentResult}
                data={assessmentData}
                onNewAnalysis={() => {
                  setShowAssessment(false);
                  setAssessmentData({});
                  setAssessmentResult(null);
                }}
                onRequestDemo={() => handleOpenDemo('Andere Branche')}
              />
            )}
          </div>
        </div>
        */}
      </div>
    </section>
  );
};

export default IndustriesSection;
